export default {
  en: {
    promotion: 'Promotion',
    pleaseSelectPromotion: '-- Please select promotion --',
    detail: 'Detail',
    periodOfStay: 'Period of Stay',
    night: 'Night',
    min: 'Min',
    max: 'Max',
    bookingPeriod: 'Booking Period',
    applyRoomType: 'Apply Room Type',
    enableAllotment: 'Enable allotment',
    roomTypeName: 'Name',
    deleted: '(Deleted)',
    cutoffDate: 'Cutoff Date',
    allotment: 'Allotment',
    showDisableRoomType: 'Show disable room type',
    remark: 'Remark',
    noData: '-- No Data --',
    selectedVersion: 'Selected versions',
    latestVersion: 'Latest versions',
    updatedPromotionMessage: 'This promotion has been updated',
    deletedPromotionMessage: 'This promotion has been deleted',
    updatedRoomTypeMessage: 'This room type has been deleted',
    deletedRoomTypeMessage: 'This room type has been deleted'
  },
  th: {
    promotion: 'โปรโมชั่น',
    pleaseSelectPromotion: '-- กรุณาเลือกโปรโมชั่น --',
    detail: 'รายละเอียด',
    periodOfStay: 'ช่วงเวลาโปรโมชั่น',
    night: 'จำนวนวัน',
    min: 'ขั้นต่ำ',
    max: 'สูงสุด',
    bookingPeriod: 'ช่วงเวลาการจอง',
    applyRoomType: 'ประเภทห้อง',
    enableAllotment: 'Enable Allotment',
    roomTypeName: 'ชื่อประเภทห้อง',
    deleted: '(Deleted)',
    cutoffDate: 'Cutoff Date',
    allotment: 'Allotment',
    showDisableRoomType: 'แสดงประเภทห้องที่ถูกระงับ',
    remark: 'หมายเหตุ',
    noData: '-- ไม่มีข้อมูล --',
    selectedVersion: 'ข้อมูลที่เลือก',
    latestVersion: 'ข้อมูลล่าสุด',
    updatedPromotionMessage: 'โปรโมชั่นนี้มีการแก้ไข',
    deletedPromotionMessage: 'โปรโมชั่นนี้ถูกลบไปแล้ว',
    updatedRoomTypeMessage: 'ประเภทห้องนี้มีการแก้ไข',
    deletedRoomTypeMessage: 'ประเภทห้องนี้ถูกลบไปแล้ว'
  }
}
